import { ChangeDetectionStrategy, Component, Inject, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
import { ControlValueAccessorValidatorBase } from '@fi-shared/control-value-accessor-validator-base';
import { fiGetLocaleCode } from '@fi-shared/utils';
import { RecaptchaComponent } from 'ng-recaptcha';
import { RecaptchaLoaderService } from 'ng-recaptcha';
import { FiCaptchaLoaderService } from '@fi-app/utilities/captcha/fi-captcha-loader.service';

@Component({
    selector: 'fi-captcha',
    template: `
        <re-captcha
            (resolved)="onCaptchaResolved($event)"
            siteKey="6LeHRBMUAAAAAHx1T9ecXjMSD_a8PUiamjDdjBYh"
        ></re-captcha>
    `,
    styleUrls: ['./fi-captcha.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FiCaptchaComponent,
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: FiCaptchaComponent,
            multi: true,
        },
    ],
    standalone: false,
})
export class FiCaptchaComponent extends ControlValueAccessorValidatorBase<string> implements OnInit {
    @Input() applicationLanguageType: number;
    @ViewChild(RecaptchaComponent, { static: false }) captcha: RecaptchaComponent;

    constructor(
        private injector: Injector,
        @Inject(RecaptchaLoaderService) private reCaptchaLoaderService: FiCaptchaLoaderService,
    ) {
        super(injector);
    }

    ngOnInit(): void {
        const isoCode = fiGetLocaleCode(this.applicationLanguageType);
        this.reCaptchaLoaderService.updateLanguage(isoCode);
    }

    doValidate(c: AbstractControl): ValidationErrors {
        return {
            required: !this.ngModel,
        };
    }

    reset() {
        this.captcha.reset();
    }

    onCaptchaResolved($event: string) {
        this.ngModel = $event;
        super.doPropagateChanges();
    }
}
